// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"097ddb59","500":"df8ddeaf","802":"492f868c"}[chunkId] + ".chunk.css";
};